export default function TitleBar(props) {
  const { icon, title } = props;

  return (
    <div className="titlebar d-flex mb-4">
      <img src={icon} alt="icon" />
      <h4 className="mb-0 lh-1">{title}</h4>
    </div>
  );
}